export default function(workoutType) {
    if (isNaN(workoutType)) {
        console.error(`workout type is not correct`);
        return '';
    }

    switch (workoutType) {
        case 0:
            return 'Quick start';
        case 1:
            return 'Aerobics';
        case 2:
            return 'Animal movement';
        case 3:
            return 'Barre';
        case 4:
            return 'Bodyweight';
        case 5:
            return 'Bootcamp';
        case 6:
            return 'Boxing';
        case 7:
            return 'Calisthenics';
        case 8:
            return 'Circuit training';
        case 9:
            return 'Conditioning';
        case 10:
            return 'Core';
        case 11:
            return 'CrossFit™';
        case 12:
            return 'HIIT';
        case 13:
            return 'Kettlebell';
        case 14:
            return 'Martial arts';
        case 15:
            return 'Military';
        case 16:
            return 'Pilates';
        case 17:
            return 'Spinning';
        case 18:
            return 'Stretching';
        case 19:
            return 'Swimming';
        case 20:
            return 'Tabata';
        case 21:
            return 'Water aerobic';
        case 22:
            return 'Weight trainin';
        case 23:
            return 'Yoga';
        case 24:
            return 'Cardio';
        case 25:
            return 'Walk';
        case 26:
            return 'Run';
        case 27:
            return 'Cycle';
        case 28:
            return 'Strongman';
        case 29:
            return 'TRX';
        case 30:
            return 'Rowing';
        case 31:
            return 'Strength training';
        case 32:
            return 'Gym';

        default:
            return '';
    }
}



// WEBPACK FOOTER //
// ./src/Utils/workoutType.js